// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-mobile_App__hIS5p {
    align-self: center;
    height: 50px;
    width: 100%;
    background-color: #297FB0;
    display: flex;
    align-items: center;

    >button {
        background-color: white;
        border-radius: 12px;
        margin: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/widgets/navigation-mobile/ui/navigation-mobile.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;;IAEnB;QACI,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;IAChB;AACJ","sourcesContent":[".App {\n    align-self: center;\n    height: 50px;\n    width: 100%;\n    background-color: #297FB0;\n    display: flex;\n    align-items: center;\n\n    >button {\n        background-color: white;\n        border-radius: 12px;\n        margin: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `navigation-mobile_App__hIS5p`
};
export default ___CSS_LOADER_EXPORT___;
